export default {
    "subscription.title": "My Subscription",
    "subscription.subtitle": "View and manage your CitoyenPro access.",

    "subscription.empty.title": "No active subscription",
    "subscription.empty.desc": "Upgrade today and master all official content with our premium tools.",
    "subscription.empty.cta": "View offers",

    "subscription.card.billing_monthly": "Monthly billing",
    "subscription.card.billing_yearly": "Yearly billing",
    "subscription.card.status.active": "Active Subscription",
    "subscription.card.status.canceled": "Canceled (Access maintained)",
    "subscription.card.status.expired": "Expired",
    "subscription.card.start_date": "Start date",
    "subscription.card.next_renewal": "Next renewal",
    "subscription.card.end_date": "End date",

    "subscription.benefits.title": "Your {{plan}} benefits",
    "subscription.benefits.standard": [
        "All themes unlocked",
        "Unlimited Quizzes & Flashcards",
        "Detailed statistics",
        "Ad-free experience"
    ],
    "subscription.benefits.premium": [
        "All themes unlocked",
        "Unlimited Mock Exams",
        "Full Audio Guides",
        "Unlimited Quizzes & Flashcards",
        "Priority support"
    ],

    "subscription.actions.continue": "Continue learning",
    "subscription.actions.compare": "Compare plans",
    "subscription.actions.renew": "Renew subscription",

    "subscription.manage.title": "Manage payments",
    "subscription.manage.desc": "Update your payment method or download your invoices via our secure Stripe portal.",
    "subscription.manage.button": "Manage subscription",
    "subscription.manage.error": "Error: {{message}}",
    "subscription.manage.error_default": "Unable to access customer portal.",
    "subscription.manage.session_expired": "Your session has expired. Please log in again.",

    "subscription.support.title": "Any issues?",
    "subscription.support.desc": "Our team is here to help with your billing or technical questions."
};
